import isNil from 'lodash/isNil';

import type { EhrChatData } from 'chaika-frontend-types/frontend-cms';

export function isChatWithDoctor(chat: EhrChatData, doctorId: string): boolean {
    return chat.doctorId === doctorId && isNil(chat.practiceId);
}
